import { render, staticRenderFns } from "./VContentLoading.vue?vue&type=template&id=29290265&"
import script from "./VContentLoading.vue?vue&type=script&lang=ts&"
export * from "./VContentLoading.vue?vue&type=script&lang=ts&"
import style0 from "./VContentLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports